import { createUseStyles } from 'react-jss'
import {
  BRIGHT_GRAY,
  DARK_GRAY_05,
  DARK_GRAY_40,
  DARK_GRAY_60,
  DARK_GRAY_80,
  DARK_GRAY,
  DARK_SECONDARY,
  DARK,
  GRAY_65,
  GRAY,
  LIGHT_GRAY,
  WHITE,
  WHITE_50
} from '@styles/colors'

const useStyles = createUseStyles({
  '@global': {
    ':root': {
      '--body__text__color': DARK_GRAY_60,
      '--link__text__color': DARK_GRAY,
      '--message__date__text__color': DARK_GRAY_40,
      '--message__header__background__color': WHITE_50,
      '--message__header__border__color': DARK_GRAY_05,
      '--primary__page__background__color': WHITE,
      '--secondary__page__background__color': WHITE,
      '--section__background__color': BRIGHT_GRAY,
      '--splash-screen__background__color': GRAY_65,
      '--tag__background__color': BRIGHT_GRAY,
      '--title__text__color': DARK_GRAY_80
    },
    '@media screen and (prefers-color-scheme: dark)': {
      ':root': {
        '--body__text__color': GRAY,
        '--link__text__color': WHITE,
        '--message__date__text__color': LIGHT_GRAY,
        '--message__header__background__color': DARK_SECONDARY,
        '--message__header__border__color': DARK_GRAY_40,
        '--primary__page__background__color': DARK,
        '--secondary__page__background__color': DARK_SECONDARY,
        '--section__background__color': DARK,
        '--splash-screen__background__color': DARK_GRAY_80,
        '--tag__background__color': DARK,
        '--title__text__color': LIGHT_GRAY
      }
    }
  }
})

export default useStyles
